module.exports = __webpack_public_path__ + "img/16device.d4a27367.png";